import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from '@/router/index';
import applicationInsights from '@/application-insights';
import { useRootStore } from '@/stores/index';

const errorHandler = (error) => {
  if (axios.isCancel(error)) {
    return Promise.reject(error);
  }

  const requestUrl = error?.response?.config?.url;
  const statusCode = error.response?.status;
  const {
    query: { aanvraagId }
  } = router.currentRoute;
  const ignoreGlobalErrorHandler =
    Object.prototype.hasOwnProperty.call(error.config, 'ignoreGlobalErrorHandler') &&
    error.config.ignoreGlobalErrorHandler === true;
  const traceProperties = {
    aanvraagId,
    ignoreGlobalErrorHandler,
    requestUrl
  };

  const rootStore = useRootStore();

  if (
    !ignoreGlobalErrorHandler &&
    (statusCode === 401 || statusCode === 403 || statusCode === 404)
  ) {
    let message;
    const { actionOnError, loginType } = error?.response?.data;
    switch (statusCode) {
      case 401:
        if (actionOnError == 'RedirectToLogin') {
          message = 'user not logged in, redirecting to login page';
          rootStore.setErrorLoggedOut({ autoStart: loginType });
          break;
        }

        message = `401 case to Unauthorized (${error})`;
        rootStore.setErrorUnauthorised();
        break;
      case 403:
        message = `403 case to Forbidden (${error})`;
        rootStore.setErrorUnauthorised();
        break;
      case 404:
        message = `404 case to Not Found (${error})`;
        rootStore.setErrorNotFound();
        break;
      default:
        throw new Error(`Unhandled Status code in axios error handling: ${statusCode}.`);
    }

    applicationInsights.trackTrace(message, traceProperties);
    return Promise.reject(error);
  }

  if (ignoreGlobalErrorHandler || (error.response && error.response.status < 500)) {
    return Promise.reject(error);
  }

  applicationInsights.trackTrace(`default case to Oeps (${error})`, traceProperties);
  rootStore.setErrorInternalServer();
  return Promise.reject(error);
};

axios.defaults.withCredentials = true;
axios.defaults.headers.get.Accept = 'application/json';

axios.interceptors.response.use(
  (response) => response,
  (error) => errorHandler(error)
);

Vue.use(VueAxios, axios);
